// extracted by mini-css-extract-plugin
module.exports = {"container":"header_container__zlHZu","title":"header_title__pn2ZE","skeleton_animate":"header_skeleton_animate__5o4xP"};